import React, { useState } from "react";
import { Box, useTheme, Grid, Typography } from "@mui/material";
import { tokens } from "../../assets/theme";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "./components/messages";
import AxionTextBox from "../../components/controls/AxionTextBox";
import Button from "../../components/controls/Button";
import { postPushMessage } from "../../hooks/pushMessage";
import { pushErrorMessage, pushNotification } from "../../utils/notifications";

export default function SendPushMessage(props) {
    const [ showSpinner, setShowSpinner ] = useState(false);
    const [ notificationMessage, setNotificationMessage ] = useState({ title: "Axjo recycling", body: "", url: "https://www.axjo.com/returnera-dina-trummor/nyheter" });
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();

    const handleChange = (event) => {
        const {id, name, value, type, checked} = event.target
        setNotificationMessage(prev => {
            return {
                ...prev,
                [id ? id : name]: type === "checkbox" ? checked : value
            }
        })
    }

    const onSendClick = () => {
        setShowSpinner(true);
        postPushMessage(notificationMessage).then((response) => {
            pushNotification(formatMessage(messages.success), 3);
            setShowSpinner(false);
        }).catch((error) => {
            pushErrorMessage(formatMessage(messages.success), 3);
            console.log("Error sending push message", error);
        }).finally(() => {
            setShowSpinner(false);
        });
        setShowSpinner(false);
    }

    return <>
        {showSpinner &&
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1000', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                <span style={{ backgroundColor: "rgba(255, 255, 255, 1)", zIndex: '10', width: "150px", height: "150px", justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: '5px' }}>
                    <img width="50px" height="50px" src="../../../assets/axion_spinner_white.gif" alt="processing..."></img>
                </span>
            </div>

        }

        <Box color={colors.primary[100]} m={2}> 
            <Box ml={1}>
                <h5><FormattedMessage {...messages.header} /></h5>
            </Box>
            <Grid container alignItems="center" width="70%" height="100%" direction="row" spacing="1px" padding="10px">
                <Grid item xs={2}>
                    <Typography><FormattedMessage {...messages.title} /></Typography>
                </Grid>
                <Grid item xs={10}>
                    <AxionTextBox 
                        id="title" 
                        label="" 
                        variant="standard" 
                        value={notificationMessage.title} 
                        name="title"
                        onChange={handleChange}
                        sx={{ width: "100%" }}
                        inputProps={{ 
                            x: { 
                                backgroundColor: '#fff', 
                                padding: '5px', 
                                color: '#000'
                            } 
                        }} />
                </Grid>
                <Grid item xs={2}>
                    <Typography><FormattedMessage {...messages.body} /></Typography>
                </Grid>
                <Grid item xs={10}>
                    <AxionTextBox 
                        id="body" 
                        label="" 
                        variant="standard" 
                        value={notificationMessage.body}
                        name="body"
                        onChange={handleChange} 
                        sx={{ width: "100%" }}
                        inputProps={{ 
                            x: { 
                                backgroundColor: '#fff', 
                                padding: '5px', 
                                color: '#000'
                            } 
                        }} />
                </Grid>
                <Grid item xs={2}>
                    <Typography><FormattedMessage {...messages.url} /></Typography>
                </Grid>
                <Grid item xs={10}>
                    <AxionTextBox 
                        id="url" 
                        label="" 
                        placeholder="" 
                        variant="standard" 
                        value={notificationMessage.url} 
                        name="url"
                        onChange={handleChange}
                        sx={{ width: "100%" }}
                        inputProps={{ 
                            x: { 
                                backgroundColor: '#fff', 
                                padding: '5px', 
                                color: '#000'
                            } 
                        }} />
                </Grid>
                <Grid item xs={2}>
                </Grid>
                <Grid item xs={10}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="md"
                        onClick={onSendClick}
                        sx={{
                            marginTop: "10px",
                            width: "175px",
                            backgroundColor: colors.dashbordGreen[500],
                            color: colors.primary[100],
                            boxShadow: "none",
                            "&:hover": {
                                backgroundColor: colors.dashbordGreen[400],
                                borderColor: "#5e7939",
                                boxShadow: "none",
                            },
                            marginRight: "0px",
                            // marginBottom: "15px",
                        }}
                        text={<FormattedMessage {...messages.send} />}
                    />
                </Grid>
            </Grid>
        </Box>
        </>
    }